import { render, staticRenderFns } from "./BaseAppAvatar.vue?vue&type=template&id=0fd0d28d&scoped=true"
import script from "./BaseAppAvatar.vue?vue&type=script&lang=js"
export * from "./BaseAppAvatar.vue?vue&type=script&lang=js"
import style0 from "./BaseAppAvatar.vue?vue&type=style&index=0&id=0fd0d28d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd0d28d",
  null
  
)

export default component.exports